import { BuildUri } from "./BuildUri";
import { NetworkManager } from "../context";

export interface TokenResponse {
    token: string;
}

// Username/password sign-in lives in the SSO app, not here — EMS only ever reads the
// session cookie the SSO issues, so there is no token-fetch endpoint on this side.
class AuthEndpoints {

    resetIdentityPassword(identityId: number): Promise<void> {
        return new Promise((resolve, reject) => {
            NetworkManager.fetch(
                BuildUri("/authentication/reset-password/{identityId}", { identityId }),
                {
                    cache: "no-cache",
                    method: "POST",
                    headers: {
                        "content-type": "application/json"
                    },
                    mode: "cors",
                    referrer: "no-referrer"
                })
                .then((response: Response) => {
                    if (response.ok) { resolve(); }
                    else { reject(response); }
                })
                .catch(err => reject(err));
        });
    }

    masquerade(targetIdentityId: number): Promise<TokenResponse> {
        return NetworkManager.fetch(
            BuildUri(
                "/authentication/masquerade/{targetIdentityId}",
                { targetIdentityId }
            ),
            { method: "POST" }
        );
    }

    endMasquerade(): Promise<TokenResponse> {
        return NetworkManager.fetch(
            BuildUri("/authentication/masquerade/end"),
            { method: "POST" }
        );
    }

    async ping(): Promise<boolean> {
        try {
            const response = await fetch(
                BuildUri("/util/ping"),
                {
                    cache: "no-cache",
                    method: "GET",
                    mode: "cors",
                    referrer: "no-referrer",
                    credentials: "include"
                }
            );
            return response.ok;
        }
        catch (e) {
            console.error("Error while pinging server", e);
            return false;
        }
    }

}

export default new AuthEndpoints();
